module.exports = angular.module('cartographer.common.api.attachment', [])

_ = require 'underscore'

module.exports.factory 'crtAttachment', $DI (
  crtLog
  $rootScope
  $window
  crtConfig
  crtPromise
  crtHttp
  crtWorkspace
  crtDatetime
  crtAuth
) ->
  _attachmentFormData = (params, file) ->
    data = new FormData()

    put = (key, value) ->
      if value? then data.append(key, value)
      return

    put("moduleId", params.moduleId)
    put("surveyId", params.surveyId)
    put("folder", params.folder.folder)
    put("filename", file.name)
    put("contentType", file.type)
    put("title", file.name)
    put("description", params.description)
    put("author.userId", params.author?.userId)
    put("author.screenName", params.author?.screenName)
    put("license", params.license)

    data.append("file", file)

    return data

  # objectid or(objectid null) -> promise(searchresults(attachment))
  search = (module, survey, folder = undefined) ->
    unless module? then throw new Error('crtAttachment.search: You must specify a survey module ID')
    unless survey? then throw new Error('crtAttachment.search: You must specify a survey ID')
    crtHttp.get("#{crtConfig.api.rootUrl}/attachment/v1", {
      module    : module
      survey    : survey
      folder : if folder? then folder else undefined
    })

  create = (params = {}, file) ->
    crtLog.debug('crtAttachment.create', params, file)

    api = {}

    api._progress = (->) # { loaded: int, total: int } xhr -> void
    api._success  = (->) #                        json xhr -> void
    api._error    = (->) #                      string xhr -> void

    api.progress  = (func) ->
      api._progress = func
      api
    api.success = (func) ->
      api._success = func
      api
    api.error = (func) ->
      api._error = func
      api

    evtToXhr = (evt) ->
      evt.srcElement || evt.target

    uploadProgress = (evt) ->
      $rootScope.$apply ->
        if evt.lengthComputable
          api._progress({ loaded: evt.loaded, total: evt.total }, xhr)
        else
          api._progress({ loaded: 40, total: 100 }, xhr)
        return
      return

    uploadComplete = (evt) ->
      $rootScope.$apply ->
        xhr = evtToXhr(evt)
        switch xhr.status
          when 200, 204
            res = JSON.parse(xhr.response)
            api._success(res, xhr)
          when 413
            res = JSON.parse(xhr.response)
            api._error(xhr.response, xhr)
          when 500
            res = JSON.parse(xhr.response)
            switch res.type
              when "InternalError"
                api._error(res, xhr)
              else
                api._error(xhr.response, xhr)
          else
            api._error(xhr.response, xhr)
        return
      return

    uploadFailed = (evt) ->
      $rootScope.$apply ->
        xhr = evtToXhr(evt)
        api._error(xhr.response, xhr)
        return
      return

    uploadCanceled = (evt) ->
      $rootScope.$apply ->
        xhr = evtToXhr(evt)
        api._error(xhr.response, xhr)
        return
      return

    xhr = new XMLHttpRequest()
    xhr.upload.addEventListener("progress", uploadProgress, false)
    xhr.addEventListener("load", uploadComplete, false)
    xhr.addEventListener("error", uploadFailed, false)
    xhr.addEventListener("abort", uploadCanceled, false)
    xhr.open("POST", "#{crtConfig.api.rootUrl}/attachment/v2", true)
    for name, value of crtHttp.requestHeaders(null)
      xhr.setRequestHeader(name, value)
    xhr.send(_attachmentFormData(params, file))

    return api

  del = (id) ->
    crtHttp.delete("#{crtConfig.api.rootUrl}/attachment/v1/#{id}")

  resolveVariant = (attach, variant = "original") ->
    token = crtAuth.credentials()?.token
    if token?
      "#{crtConfig.api.rootUrl}/attachment/v1/#{attach.id}/#{variant}?authorization=#{token}"
    else
      null

  resolveOriginal = (attach) ->
    resolveVariant(attach, "original")

  resolvePreview = (attach) ->
    resolveVariant(attach, "preview")

  resolveThumbnail = (attach, variant = "640x480") ->
    resolveVariant(attach, variant)

  return {
    search
    create
    delete: del
    resolveVariant
    resolveOriginal
    resolvePreview
    resolveThumbnail
  }
